export const AssertionRecipe = {
    $type$: 'Recipe',
    name: 'Assertion',
    rule: [
        {
            itemprop: 'target',
            itemtype: {
                type: 'string',
                regexp: /^[0-9a-f]{64}$/
            },
            isId: true
        },
        {
            itemprop: 'assertedBy',
            itemtype: {
                type: 'referenceToId',
                allowedTypes: new Set(['Person'])
            }
        },
        {
            itemprop: 'instanceId',
            itemtype: {
                type: 'referenceToId',
                allowedTypes: new Set(['Instance'])
            }
        },
        {
            itemprop: 'signature',
            itemtype: { type: 'string' },
            optional: true
        },
        {
            itemprop: 'createdAt',
            itemtype: { type: 'integer' }
        },
        {
            itemprop: 'expiresAt',
            itemtype: { type: 'integer' },
            optional: true
        }
    ]
};
const AssertionRecipes = [AssertionRecipe];
export default AssertionRecipes;
//# sourceMappingURL=AssertionRecipes.js.map